import React from 'react'

const CLICK_MOVE_THRESHOLD = 10 // px；小于此距离仍视为点击，避免 PC 轻微抖动吞掉首次点击

const withSliderTouch = (Component) => {
  return class extends React.Component {
    state = {
      disableClick: false
    }

    startX = 0
    startY = 0

    handleMouseDown = (e) => {
      this.startX = e.clientX
      this.startY = e.clientY
      this.setState({
        disableClick: false
      })
    }

    handleMouseMove = (e) => {
      if (this.state.disableClick) {
        return
      }

      const deltaX = Math.abs(e.clientX - this.startX)
      const deltaY = Math.abs(e.clientY - this.startY)

      if (deltaX > CLICK_MOVE_THRESHOLD || deltaY > CLICK_MOVE_THRESHOLD) {
        this.setState({
          disableClick: true
        })
      }
    }

    handleMouseLeave = () => {
      this.setState({
        disableClick: false
      })
    }

    render() {
      return (
        <div
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseLeave={this.handleMouseLeave}
        >
          <Component {...this.props} disableClick={this.state.disableClick}/>
        </div>
      )
    }
  }
}

export default withSliderTouch
